/*
 * @Author: ken yang
 * @Date: 2023-09-11 10:22:48
 * @LastEditTime: 2023-09-11 10:58:16
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_pc/src/view/futures/index.js
 */

import AppLayout from '@/layout/AppLayout.vue'

const Futures = () => import('@/view/futures/Futures.vue')
const CoinStockFutures = () => import('@/view/futures/CoinStockFutures.vue')
// const GridLayout = () => import('@/view/futures/GridLayout.vue')
const FuturesInfo = () => import('@/view/futures/pages/FuturesInfo.vue')
const FollowOrderInfo = () => import('@/view/futures/pages/FollowOrderInfo.vue')

// const Futures = () => import('@/view/futures/Futures.vue')

const routes = [
  {
    component: AppLayout,
    children: [
      {
        path: '/futures',
        props: route => ({ symbol: route.query.symbol }),
        component: Futures,
        meta: { key: 'futures' },
      },
      {
        path: '/futures-info',
        component: FuturesInfo,
        meta: { key: 'FuturesInfo' },
      },
      {
        path: '/follow-order-info',
        component: FollowOrderInfo,
        meta: { key: 'FollowOrderInfo' },
      },
      {
        path: '/coinStockFutures',
        props: route => ({ symbol: route.query.symbol }),
        component: CoinStockFutures,
        meta: { key: 'coinStockFutures' },
      },
    ]
  },
]
const components = {}

export default {
  routes,
  components,
}
